import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css' 
import api from "@/utils/request"
Vue.prototype.$api= api
Vue.config.productionTip = false
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import horizontalScroll from 'el-table-horizontal-scroll' //el-table 滚动条
Vue.use(horizontalScroll)
import router from './router/router'
new Vue({
  render: h => h(App),
  router,
  beforeCreate(){
    Vue.prototype.$bus = this //安装 全局事件总线 this指向vue原型
  }
}).$mount('#app')
